/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_Ac_2Inputs */

const en_pc_cmp_ac_2 = /** @type {(inputs: Pc_Cmp_Ac_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You convert between PDF and Word, Excel or PowerPoint every day.`)
};

const zh_pc_cmp_ac_2 = /** @type {(inputs: Pc_Cmp_Ac_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你每天都要在 PDF 与 Word、Excel、PowerPoint 之间转换。`)
};

/**
* | output |
* | --- |
* | "You convert between PDF and Word, Excel or PowerPoint every day." |
*
* @param {Pc_Cmp_Ac_2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_ac_2 = /** @type {((inputs?: Pc_Cmp_Ac_2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_Ac_2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_ac_2(inputs)
	return zh_pc_cmp_ac_2(inputs)
});
export { pc_cmp_ac_2 as "pc.cmp.ac.2" }